import { gql } from "@apollo/client";

const GET_LOCATIONS = gql`
  query getLocations($params: QueryParams, $name: String) {
    locations(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        name
        phone
        img
        collectionInstructions
        subZone {
          id
          name
        }
        address {
          fullName
          street
          colony
          exteriorNumber
          postcode
          city
          state
          country
          location {
            type
            coordinates
          }
        }
        products {
          id
          name
          description
          variants {
            id
            title
            img
            description
            price
            isPrimaryVariant
          }
          type
        }
        users {
          id
          firstName
          lastName
          type
        }
        operations {
          integrations{
            conekta{
            conekta_id
            }
}
        workingHours{
         monday{
         open
         close}
         tuesday{
         open
         close}
          wednesday{
          open
          close}
          thursday{
          open
          close}
          friday{
          open
          close}
          saturday{
          open
          close}
          sunday{
          open
          close}
        }
        holidays{
        date
        repeat
        isOpen
        hours{
        open
        close}}}
      }
    }
  }
`;

export { GET_LOCATIONS };
